export default {
  sm: `
    DATA CENTER GAK is preparing for the future generations and data age through creating new values using data.
  `,
};
